import axios from '../assets/axios'
import { getKey, setKey, addCookie, getCookie, initGId } from '../assets/utils'
import UUID from 'uuidjs'
// import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
// import originAxios from 'axios'

// const axiosInstance = originAxios.create({
//   headers: {
//     'content-type': 'application/json;charset=UTF-8'
//   }
// })

let timer = null

export function generateUUID (uid) {
  // 从IOS过来的uid
  if (uid) {
    addCookie('uuid', uid)
    setKey('uuid', uid)
    return uid
  }
  // 甜美贷访客唯一标志,在未登录时就标记用户
  let uId = getCookie('uuid') || getKey('uuid')
  if (!uId) {
    uId = UUID.genV4().toString()
    addCookie('uuid', uId)
    setKey('uuid', uId)
    timer = setInterval(() => {
      // 循环依赖
      // 生成uuid埋点
      if (report && axios) {
        report({
          id: 20001,
          args: {
            target: uId
          },
          ts: Date.now()
        })
        clearInterval(timer)
      }
    }, 100)
  }
  return uId
}

generateUUID()
initGId()

// const blackList = [10128] // 一些webview不需要埋的点
const report = (logs) => {
  return true
}
// const reportBack = (logs) => {
//   // 日志可以是单个对象，id小于10000的埋点是专门用来调试问题的
//   logs.channel = getKey('channel') || 'official'
//   if (hasNativeMethod('analytics') && logs.id > 10000) {
//     // 一些webview不需要埋的点
//     if (logs instanceof Array) {
//       logs = logs.filter(log => !blackList.includes(log.id))
//       logs.map(item => {
//         item.path = '/index/v1/point'
//         return item
//       })
//       if (!logs.length) return
//     } else {
//       if (blackList.includes(logs.id)) return
//     }
//     logs.path = '/index/v1/point'
//     return jsBridge('analytics', logs)
//   } else {
//     if (!(logs instanceof Array)) logs = [logs]
//     // console.log('====埋点====', JSON.stringify(logs))
//     let params = {
//       upload_ts: Date.now(),
//       uuid: generateUUID(),
//       phone: getKey('userInfo', 'mobile'),
//       logs: JSON.stringify(logs),
//       ua: window.navigator.userAgent
//     }
//     if (getKey('gid')) {
//       params.supplement = JSON.stringify({
//         gid: localStorage.getItem('gid')
//       })
//     }
//     return axios.post('/index/v1/point', params).then(
//       res => {
//         if (res.data && res.data.code === 'OK') return true // 埋点成功
//         else return false // 埋点失败
//     }, e => false).catch(e => false) // 埋点失败
//   }
// }

export function statisticsReport (node, args) {
  return true
  // let params = {
  //   createTime: Date.now(),
  //   gid: localStorage.getItem('gid') || '',
  //   uuid: generateUUID() || '',
  //   mobile: getKey('userInfo', 'mobile'),
  //   channel: getKey('channel') || 'official',
  //   platform: getKey('terminal') || 'H5',
  //   node
  // }
  // params = { ...params, ...args }
  // console.log('======埋点======:' + node)
  // console.log(JSON.stringify(params))
  // if (process.env.VUE_APP_CURRENTMODE === 'production') {
  //   return axiosInstance.get('/statistics/api/v1/record/add', { params }).then(res => res)
  // } else {
  //   return false
  // }
}

export default report
